import React from "react";
import { createRoot } from "react-dom/client";
import "swiper/css";
import "url-search-params-polyfill";
import App from "./App";

import "./style/calendar.css";
import "./style/featured.css";
import "./style/header.css";
import "./style/index.css";
import "./style/menu.css";
import "./style/nav.css";
import "./style/print.css";
import "./style/swiper.css";
import "./style/tailwind.css";
import "./style/today.css";
import "./style/weather.css";

const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
